module.exports = __webpack_public_path__ + "static/media/rolling-dices.140136ab.svg";